// ✅ src/screens/SettingsScreen.js (FULL - UPDATED)
// ✅ Admin button (ONLY email: k16278422@gmail.com)
// ✅ Contact Us (everyone can see)
// ✅ Download app row now navigates to /download-app
// ✅ HARD DELETE account via Cloud Function deleteEverything (type DELETE confirm)

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, functions } from "../lib/firebase";
import { httpsCallable } from "firebase/functions";

const ADMIN_EMAIL = "k16278422@gmail.com";

export default function SettingsScreen() {
  const nav = useNavigate();

  // ✅ track current user email
  const [email, setEmail] = useState("");

  // ✅ delete modal state
  const [showDelete, setShowDelete] = useState(false);
  const [deleteText, setDeleteText] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (!u) {
        nav("/login", { replace: true });
        return;
      }
      setEmail(String(u.email || "").toLowerCase());
    });
    return () => unsub();
  }, [nav]);

  const isAdmin = email === ADMIN_EMAIL.toLowerCase();

  // ✅ HARD DELETE (Cloud Function)
  async function onDeleteAccount() {
    const u = auth.currentUser;
    if (!u) return;

    if (deleteText.trim().toUpperCase() !== "DELETE") {
      setMsg('Type "DELETE" to confirm.');
      return;
    }

    try {
      setDeleting(true);
      setMsg("");

      // 🔥 This must delete: auth user + firestore docs + storage files, etc.
      const fn = httpsCallable(functions, "deleteEverything");
      await fn({ confirm: "DELETE" });

      // sign out (best effort)
      try {
        await signOut(auth);
      } catch {}

      // clear cache (best effort)
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch {}

      // go to signup/login
      window.location.replace("/signup");
    } catch (e) {
      console.error(e);
      setMsg(e?.message || "Failed to delete everything.");
    } finally {
      setDeleting(false);
    }
  }

  return (
    <div style={S.settingsWrap}>
      {/* top message */}
      {msg ? (
        <div style={{ ...S.info, borderColor: "rgba(239,68,68,.25)", color: "#b91c1c" }}>
          {msg}
        </div>
      ) : null}

      <button type="button" style={S.settingsRow} onClick={() => nav("/profile-details")}>
        <span style={S.settingsIcon}>👤</span>
        <span style={S.settingsText}>Profile</span>
        <span style={S.settingsChev}>›</span>
      </button>

      <button type="button" style={S.settingsRow} onClick={() => nav("/edit-profile")}>
        <span style={S.settingsIcon}>✏️</span>
        <span style={S.settingsText}>Edit profile</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* ✅ Buy gifts */}
      <button type="button" style={S.settingsRow} onClick={() => nav("/buy-gifts")}>
        <span style={S.settingsIcon}>🎁</span>
        <span style={S.settingsText}>Buy gifts</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* ✅ Withdraw */}
      <button type="button" style={S.settingsRow} onClick={() => nav("/withdraw")}>
        <span style={S.settingsIcon}>💸</span>
        <span style={S.settingsText}>wallet/Withdraw</span>
        <span style={S.settingsChev}>›</span>
      </button>

      <button type="button" style={S.settingsRow} onClick={() => nav("/notifications")}>
        <span style={S.settingsIcon}>🔔</span>
        <span style={S.settingsText}>Notifications</span>
        <span style={S.settingsChev}>›</span>
      </button>

      <button type="button" style={S.settingsRow} onClick={() => nav("/upgrade")}>
        <span style={S.settingsIcon}>⭐</span>
        <span style={S.settingsText}>Upgrade</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* ✅ Download app -> goes to DownloadAppScreen */}
      <button type="button" style={S.settingsRow} onClick={() => nav("/download-app")}>
        <span style={S.settingsIcon}>⬇️</span>
        <span style={S.settingsText}>Download app to screen</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* ✅ Admin (ONLY this email can see it) */}
      {isAdmin ? (
        <button type="button" style={S.settingsRow} onClick={() => nav("/admin")}>
          <span style={S.settingsIcon}>🛡️</span>
          <span style={S.settingsText}>Admin</span>
          <span style={S.settingsChev}>›</span>
        </button>
      ) : null}

      {/* ✅ Contact Us (everyone) */}
      <button type="button" style={S.settingsRow} onClick={() => nav("/contact")}>
        <span style={S.settingsIcon}>📩</span>
        <span style={S.settingsText}>Contact us</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* ✅ Delete account (opens modal) */}
      <button
        type="button"
        style={{ ...S.settingsRow, borderColor: "rgba(239,68,68,.25)" }}
        onClick={() => {
          setMsg("");
          setDeleteText("");
          setShowDelete(true);
        }}
      >
        <span style={S.settingsIcon}>🗑️</span>
        <span style={{ ...S.settingsText, color: "#b91c1c" }}>Delete account</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* Logout */}
      <button
        type="button"
        style={{ ...S.settingsRow, borderColor: "rgba(239,68,68,.25)" }}
        onClick={async () => {
          try {
            await signOut(auth);
          } catch {}
          nav("/login", { replace: true });
        }}
      >
        <span style={S.settingsIcon}>🚪</span>
        <span style={S.settingsText}>Logout</span>
        <span style={S.settingsChev}>›</span>
      </button>

      {/* DELETE MODAL */}
      {showDelete ? (
        <div style={S.modalBackdrop} onClick={() => !deleting && setShowDelete(false)}>
          <div style={S.modal} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalTitle}>Delete account permanently?</div>

            <div style={S.modalText}>
              This will permanently delete your <b>account</b> and related data (profile, chats,
              images, etc). This cannot be undone.
            </div>

            <div style={{ ...S.modalLabel, marginTop: 8 }}>
              Type <b>DELETE</b> to confirm
            </div>

            <input
              style={S.modalInput}
              value={deleteText}
              onChange={(e) => setDeleteText(e.target.value)}
              placeholder="DELETE"
              disabled={deleting}
            />

            <div style={S.modalActions}>
              <button style={S.softBtn} onClick={() => setShowDelete(false)} disabled={deleting}>
                Cancel
              </button>

              <button
                style={S.dangerBtn}
                onClick={onDeleteAccount}
                disabled={deleting || deleteText.trim().toUpperCase() !== "DELETE"}
              >
                {deleting ? "Deleting…" : "Delete forever"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

/* ---------------- styles ---------------- */
const S = {
  settingsWrap: { display: "grid", gap: 10 },
  info: {
    border: "1px solid rgba(2,6,23,0.07)",
    background: "rgba(255,255,255,0.70)",
    borderRadius: 18,
    padding: 12,
    fontWeight: 1000,
  },
  settingsRow: {
    width: "100%",
    borderRadius: 18,
    border: "1px solid rgba(2,6,23,0.07)",
    background: "rgba(255,255,255,0.70)",
    boxShadow: "0 14px 34px rgba(2,6,23,0.06)",
    padding: 12,
    display: "grid",
    gridTemplateColumns: "42px 1fr 18px",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    textAlign: "left",
  },
  settingsIcon: {
    width: 42,
    height: 42,
    borderRadius: 16,
    display: "grid",
    placeItems: "center",
    background: "rgba(255,255,255,0.80)",
    border: "1px solid rgba(2,6,23,0.06)",
    fontWeight: 1000,
  },
  settingsText: { fontWeight: 1000 },
  settingsChev: { fontSize: 22, fontWeight: 1000, opacity: 0.35 },

  // modal
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,.45)",
    display: "grid",
    placeItems: "center",
    padding: 16,
    zIndex: 9999,
  },
  modal: {
    width: "min(520px, 100%)",
    background: "#fff",
    border: "1px solid #e7ecf6",
    borderRadius: 18,
    padding: 14,
    boxShadow: "0 24px 60px rgba(15,23,42,.22)",
    display: "grid",
    gap: 10,
  },
  modalTitle: { fontWeight: 1100, fontSize: 16 },
  modalText: { color: "#0f172a", fontWeight: 900, fontSize: 13, lineHeight: 1.35 },
  modalLabel: { color: "#64748b", fontWeight: 900, fontSize: 12, marginBottom: 6 },
  modalInput: {
    width: "100%",
    border: "1px solid #cbd5e1",
    borderRadius: 12,
    padding: 10,
    fontWeight: 900,
    outline: "none",
    background: "#fff",
  },
  modalActions: { display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 8 },
  softBtn: {
    border: "1px solid #e7ecf6",
    background: "#ffffff",
    borderRadius: 12,
    padding: "9px 12px",
    fontWeight: 950,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(15,23,42,0.05)",
  },
  dangerBtn: {
    border: 0,
    background: "#ef4444",
    color: "#fff",
    borderRadius: 12,
    padding: "10px 12px",
    fontWeight: 1000,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(239,68,68,0.18)",
    opacity: 1,
  },
};